<template>
  <div class="content-header-container">
    <div class="content-header">
      <div class="search-box" :class="{'open-search-box':$root.layout.searchBox}">
        <input type="text" ref="searchBox" placeholder="Aranacak şeyi yazın"
               @keydown.esc="$root.layout.searchBox = !$root.layout.searchBox"/>
        <button type="button" @click="$root.layout.searchBox = !$root.layout.searchBox;"><i class="fa fa-close"></i>
        </button>
      </div>
      <nav class="top-nav-bar">
        <ul class="left">
          <li><a @click="toggleSideBar"><i class="fa fa-bars"></i> </a></li>
          <li><a @click="handleFullScreen"><i class="fa fa-expand"></i> </a></li>
          <li><a @click="handleSearchButton"><i class="fa fa-search"></i> </a></li>
        </ul>
        <ul class="right">
          <li>
            <el-tag type="success" v-if="$root.checkRole(['ROLE_ADMIN'])">Yönetici</el-tag>
            <el-tag type="primary" v-if="$root.checkRole(['ROLE_POINT'])">Ödeme Noktası</el-tag>
            <el-tag type="info" v-if="$root.checkRole(['ROLE_CUSTOMER'])">Müşteri</el-tag>
            <el-tag type="danger" v-if="$root.checkRole(['ROLE_DEALER'])">Bayi</el-tag>
          </li>
          <li>
            <div class="dropdown">
              <a data-toggle="dropdown">
                {{$root.user.fullName}}
              </a>
              <div class="dropdown-menu">

                <router-link class="dropdown-item" to="/logout">Çıkış Yap</router-link>

              </div>
            </div>
          </li>
        </ul>
      </nav>
    </div>
  </div>

</template>

<script>
  export default {
    name: 'ContentHeader',
    data() {
      return {
        isFullScreen: false
      }
    },
    created() {

    },
    methods: {
      handleFullScreen() {
        let element = document.documentElement;
        if (!this.isFullScreen) {
          this.isFullScreen = true;
          if (element.requestFullscreen) {
            element.requestFullscreen();
          } else if (element.mozRequestFullScreen) {
            element.mozRequestFullScreen();
          } else if (element.webkitRequestFullscreen) {
            element.webkitRequestFullscreen();
          } else if (element.msRequestFullscreen) {
            element.msRequestFullscreen();
          }
        } else {
          this.isFullScreen = false;
          if (document.exitFullscreen) {
            document.exitFullscreen();
          } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
          } else if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen();
          }
        }
      },
      toggleSideBar() {
        this.$root.layout.sideBarCollapse = !this.$root.layout.sideBarCollapse;
      },
      handleSearchButton() {
        this.$root.layout.searchBox = !this.$root.layout.searchBox;
        this.$refs.searchBox.focus();
      }
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Base/ContentHeader.vue